// import "./AnimatedBar.scss";
import { ReactComponent as MaGo3dIcon } from "../../svg/mago3d.svg";

export default function AnimatedBar() {
  return (
    <div className="scrolling-text">
      <div className="scrolling-text_inner direction-left">
        <div>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          {/* <span className="scrolling-text__item">•</span> */}
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
        </div>
        <div>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
          <span className="scrolling-text__item">ONLY IMAGINATION</span>
          <span className="scrolling-text__item">
            <MaGo3dIcon className="icon-animated-bar" />
          </span>
        </div>
      </div>
    </div>
  );
}
